import SentMailStatusTag from "@/component/tag/SentMailStatusTag.tsx";
import { DateHelper, StringHelper } from "@/constant/helper.ts";
import { DownloadFileButton } from "@/view/license/component/DownloadFileButton.tsx";
import { TableProps } from "antd";
import { TFunction } from "i18next";

export const LicenseTableHeader = (
  t: TFunction,
  registration?: LicenseRegistrationDetail,
): TableProps<LicenseItemSearch>["columns"] => {
  return [
    {
      title: t("field.no"),
      dataIndex: "no",
      key: "no",
      align: "center",
      render: (_, _record, index) => <span>{index + 1}</span>,
    },
    {
      title: t("field.issuedDate"),
      dataIndex: "createdDate",
      key: "createdDate",
      render: (_, { createdDate }) => {
        return (
          <>
            {createdDate ? (
              <div>{DateHelper.convertDateToStringDateTime(createdDate)}</div>
            ) : (
              <div>----/--/--</div>
            )}
          </>
        );
      },
    },
    {
      title: t("field.expiredDate"),
      dataIndex: "expiredDate",
      key: "expiredDate",
      render: (_, { expiredDate }) => {
        return (
          <>
            {expiredDate ? (
              <div>{DateHelper.convertDateToStringDate(expiredDate)}</div>
            ) : (
              <div>----/--/--</div>
            )}
          </>
        );
      },
    },
    {
      title: t("field.licenseFileUrl"),
      dataIndex: "licenseFileUrl",
      key: "licenseFileUrl",
      align: "center",
      render: (_, { licenseFileUrl }) => (
        <DownloadFileButton
          url={`/media-minio/download/${licenseFileUrl}` || undefined}
          fileName={
            StringHelper.getFileNameFromUrl(licenseFileUrl) || undefined
          }
        />
      ),
    },
    {
      title: t("field.fileName"),
      dataIndex: "fileName",
      key: "fileName",
      render: (_, { licenseFileUrl }) => (
        <>{StringHelper.getFileNameFromUrl(licenseFileUrl)}</>
      ),
    },
    {
      title: t("field.sentMailStatus"),
      dataIndex: "sentStatus",
      key: "sentStatus",
      render: () => <SentMailStatusTag status={registration?.sentMail} />,
    },
  ];
};
